const TaxRollWorkFileHeaders = [
  {
    text: 'Type',
    value: 'taxType',
    sortable: false,
  },
  {
    text: 'Year',
    value: 'taxYear',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    align: 'left',
    sortable: true,
  },
  {
    text: 'Parcel ID',
    value: 'propertyOrParcelId',
    align: 'left',
    sortable: true,
    formatter: 'pId',
  },
  {
    text: 'Owner Name',
    value: 'ownerName',
    align: 'left',
    sortable: true,
  },
  {
    text: 'Tax Amt Due',
    value: 'totalDue',
    align: 'right',
    sortable: true,
    formatter: 'amount',
  },
  {
    text: 'Mtg Code',
    value: 'mtgCode',
    align: 'left',
    sortable: true,
  },
  {
    text: 'SD',
    value: 'schoolDistrict',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Email Address',
    value: 'emailAddess',
    align: 'left',
    sortable: false,
  },
];
const FeeManagementHeaders = [
  {
    text: 'Tax Year',
    value: 'taxYear',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    align: 'left',
    sortable: false,
    formatter: 'paragraph',
  },
  {
    text: 'Owner Name',
    value: 'taxInquiryTransaction.name1',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Fee #',
    value: 'feeNumber',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Fee Description',
    value: 'feeDescription',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Fee Amount',
    value: 'feeAmount',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Effective Date',
    value: 'effectiveDate',
    formatter: 'shortDate',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Payment Date',
    value: 'paymentDate',
    formatter: 'shortDate',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Payment #',
    value: 'paymentNumber',
    align: 'center',
    sortable: false,
  },
];

const tabsForTaxRollWorkFile = [
  {
    id: 0,
    tab: 'Tax Info',
  },
  {
    id: 1,
    tab: 'Owner Info',
  },
  {
    id: 2,
    tab: 'Comments',
  },
  {
    id: 3,
    tab: 'Adjustments',
  },
  {
    id: 4,
    tab: 'Mobile',
  },
];

export { TaxRollWorkFileHeaders, FeeManagementHeaders, tabsForTaxRollWorkFile };
